<script lang="ts">
  import { EntityForm, Form } from '$shared/components';
  import type { Snippet } from 'svelte';
  import type { FormLayoutOption } from '$shared/components/types';

  interface Props {
    option: FormLayoutOption;
    headerAction?: Snippet | undefined;
    children?: import('svelte').Snippet;
    onok?: () => void;
    oncancel?: () => void;
    onalertclose?: () => void;
  }

  let { option, headerAction = undefined, children, onok, oncancel, onalertclose }: Props = $props();

  let entityForm: EntityForm = $state();

  export const scrollToErrorView = (): void => {
    entityForm?.scrollToErrorView();
  };
</script>

<div class="comp-form-layout">
  {#if option}
    <EntityForm
      bind:this={entityForm}
      loading={option?.loading}
      title={option.title}
      hideCancel={!!option.hideCancel}
      okLabel={option.okLabel || 'Save'}
      {headerAction}
      {onok}
      {oncancel}
    >
      <Form error={option.error} {onalertclose}>
        {@render children?.()}
      </Form>
    </EntityForm>
  {:else}
    <div class="invalid">Invalid Form Option</div>
  {/if}
</div>

<style>
  .invalid {
    color: var(--grey-medium);
  }
</style>
